// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fdfe1763","152":"95424208","264":"74cbe9ba","446":"87c909d5","470":"a849e294","478":"8f968aa7","497":"b8a27525","561":"91543b4b","637":"abf7b2b7","683":"71096d31","952":"51405f33","960":"19aa12b0"}[chunkId] + ".chunk.css";
};